export default __webpack_public_path__ + "static/media/video.62135cde.svg";